/**
 * A service wrapper for the PrimaryPlanFactory methods so we can cache the response
 * locally and not make consecutive API requests.
 */
const PrimaryPlanService = function ($injector) {
    const service = {};
    const data = {};
    const logger = $injector.get("$log").getInstance("PlanService");
    const $q = $injector.get("$q");
    const primaryPlanFactory = $injector.get("primaryPlanFactory");
    const getPrimaryPlanDeferred = $q.defer();
    let getPrimaryPlanRequestOut = false;

    /**
     * Accessor function to the PrimaryPlanFactory::get API
     */
    service.getPrimaryPlan = function () {
        logger.debug("getPrimaryPlan()");

        if (!data.primaryPlan) {
            // Don't make the API call if there is already a request out. All
            // calls will get the same result when the promise resolves
            if (!getPrimaryPlanRequestOut) {
                getPrimaryPlanRequestOut = true;

                primaryPlanFactory.get({}, onGetPrimaryPlanSuccess, onGetPrimaryPlanFailure);
            }
        } else {
            logger.debug("Primary Plan data was cached in the service; returning {0}", [
                data.primaryPlan
            ]);

            // data is cached locally, so we don't need to fetch it
            getPrimaryPlanDeferred.resolve(data.primaryPlan);
        }

        function onGetPrimaryPlanSuccess(primaryPlan) {
            logger.debug("Primary Plan API request was successful; returning {0}", [primaryPlan]);

            getPrimaryPlanRequestOut = false;

            // Cache the response
            data.primaryPlan = primaryPlan;

            getPrimaryPlanDeferred.resolve(primaryPlan);
        }

        function onGetPrimaryPlanFailure(errorMessage) {
            logger.error("Failed to get primary plan: {0}", [errorMessage]);

            getPrimaryPlanDeferred.reject(errorMessage);
        }

        return getPrimaryPlanDeferred.promise;
    };

    return service;
};

PrimaryPlanService.$inject = ["$injector"];
export default PrimaryPlanService;
